/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getHoldingsHistoricalData} from '../api'

 export const useQueryGetHoldingsHistoricalData = createReactQueryHook('getHoldingsHistoricalData', getHoldingsHistoricalData)
